interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
}

export default function EmptyState({ icon = 'ri-inbox-line', title, description }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-16 text-center">
      <div className="flex h-14 w-14 items-center justify-center rounded-full bg-background-100 text-foreground-400">
        <i className={`${icon} text-2xl`} />
      </div>
      <p className="mt-4 font-heading text-base font-semibold text-foreground-800">{title}</p>
      {description && <p className="mt-1 text-sm text-foreground-500">{description}</p>}
    </div>
  );
}